import { convCol } from './css-filter'
import { queryClient } from './reactQueryClient'

/**
 * Sets colors for the theme.
 *
 * @param {string} primary - The primary color to be used by the theme.
 * @param {string} secondary - The secondary color to be used by the theme.
 * @param {string} favicon - The favicon to be inserted into the HTML head tag.
 */
export const mainUILoad = (primary, secondary, favicon) => {
  const favLink = document.getElementById('faviconLink') || null
  if (favLink !== null) {
    favLink.setAttribute('href', favicon)
  }
  document.body.classList.add('vertical-layout')
  const col1 = convCol(secondary)
  const col2 = convCol(primary)

  document.documentElement.style.setProperty('--mainPrimaryCol', primary)
  document.documentElement.style.setProperty('--mainPrimaryColHover', primary)

  document.documentElement.style.setProperty('--primaryCol', col1)
  document.documentElement.style.setProperty('--primaryCol-hover', col2)
}

/**
 * Unloads CSS files from the HTML document.
 */
export function unloadCSS() {
  var links = document.querySelectorAll('link[type="text/css"]')
  var linksArray = Array.prototype.slice.call(links)
  linksArray.forEach(function (child) {
    child.parentNode.removeChild(child)
  })
}

/**
 * Checks if a string is a valid JSON string.
 *
 * @param {string} str - The string to be checked.
 * @returns {boolean} True if the string is valid JSON, false otherwise.
 */
export const isValidJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

function sortFunc(results, sortType, sortByField) {
  if (sortType === 'ascending') {
    results.sort((a, b) => (a[sortByField] < b[sortByField] ? -1 : 1))
  } else if (sortType === 'descending') {
    results.sort((a, b) => (b[sortByField] > a[sortByField] ? 1 : -1))
  }
  return results
}

// Dropdown to sort posts in ascending or descending order depending on title.
export const updateResult = (e, modSchema, setSortType, sortType) => {
  const initialData = queryClient.getQueryData(modSchema.api)
  setSortType(e)
  let result
  const filtered = sortFunc(initialData.formData, sortType, e) || sortFunc(result, sortType, e)
  queryClient.setQueryData(modSchema.api, { formData: filtered })
}

export const sortBy = (e, modSchema, sortType) => {
  const initialData = queryClient.getQueryData(modSchema.api)
  let result
  const filtered = sortFunc(initialData.formData, sortType, e) || sortFunc(result, sortType, e)
  queryClient.setQueryData(modSchema.api, { formData: filtered })
}

export const handleSearch = (e, setAllSFSData, schema, allSFSData) => {
  let filtered
  if (allSFSData === null) {
    const initialData = queryClient.getQueryData(schema.api)
    setAllSFSData(initialData)
    filtered = initialData.formData.filter((entry) => {
      if (e.target.value === '') {
        const resp = allSFSData.formData
        setAllSFSData(null)
        return resp
      }
      return Object.values(entry).some(
        (val) =>
          typeof val === 'string' && val.toLowerCase().includes(e.target.value.toLowerCase()),
      )
    })
    queryClient.setQueryData(schema.api, { formData: filtered })
  } else {
    const initialData = queryClient.getQueryData(schema.api)
    if (e.target.value === '') {
      const resp = allSFSData.formData
      setAllSFSData(null)
      queryClient.invalidateQueries(schema.api)
      queryClient.setQueryData(schema.api, { formData: resp })
      return resp
    }
    filtered = initialData.formData.filter((entry) => {
      return Object.values(entry).some(
        (val) =>
          typeof val === 'string' && val.toLowerCase().includes(e.target.value.toLowerCase()),
      )
    })
    queryClient.setQueryData(schema.api, { formData: filtered })
  }
}
